var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.scrolled?'visible':'hidden'],attrs:{"id":"back-to-top"},on:{"click":function($event){_vm.goToTop()}}},[_c('img',{attrs:{"src":(_vm.$STATIC_PATH + "/img/back_to_top_snapshot_40.png"),"alt":"Back to top"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe5c5366","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sqs/2019/BackToTop.vue
// module id = null
// module chunks = 